<div class="fgbcl-game-counter-container">
  <span (click)="increment()" class="material-icons-outlined">keyboard_arrow_up</span>

  <input
    type="number"
    class="fgbcl-game-counter-display fgbcl-game-counter-input"
    [value]="count"
    (input)="onInput($event)"
    (keydown)="preventInvalidInput($event)"
  />

  <span [ngClass]="{ 'fgbcl-game-counter-disabled': count == 0 }" (click)="decrement()" class="material-icons-outlined">
    keyboard_arrow_down
  </span>
</div>
